import { useEffect, useState } from 'react'
import { Button } from '../../components/ui/button'
import { styles } from '../../styles/tailwind-config'
import { AlertTriangle, ArrowLeftIcon } from 'lucide-react'
import { Label } from '../../components/ui/label'
import { Input } from '../../components/ui/input'
import { Link } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import axios from '../../lib/axios'
import Spinner from '../../components/ui/spinner'
import boxlogo from '../../assets/logo/logo-mountq-full.svg'
import security from '../../assets/illustrations/technicians-people.svg'
import { Trans, useLingui } from '@lingui/react/macro';
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'


const ForgotPassword = () => {
    const { t } = useLingui()

    const [email, setemail] = useState('');


    const { mutate:handleRequestPassword, reset:resetRequestPassword, isPending, isError, isSuccess } = useMutation({
        mutationFn: async () => {
            const { data } = await axios.post(`password/request`, { email:email })
            console.log(data)
            toast.success(t`Wachtwoord aangevraagd`, { id:'handleRequestPassword' })
            return true
        },
        onError: (e) => {
            console.log(e)
            toast.error(t`Er is een fout opgetreden`, { id:'handleRequestPassword' })
            setTimeout(()=>{resetRequestPassword()}, 2000)
        }
    })

  return (
    <div className='flex flex-col items-center justify-between h-dvh max-h-dvh w-dvw bg-slate-100'>
        <div className='flex items-center gap-1 py-4'>
            <img className='w-auto h-12' src={boxlogo} alt="MountQ logo"/>
        </div>

        <div className='flex flex-col items-center w-full'>
            <img className='w-full max-w-xs translate-y-10' src={security} alt="MountQ security"/>
            <div className='z-10 flex flex-col items-center w-full max-w-3xl gap-6 p-10 bg-white shadow-2xl md:p-20 rounded-t-3xl'>
                <div className='flex justify-between w-full'>
                      <Link to="/login" className='flex items-center justify-center gap-2 p-2 text-sm font-medium rounded-sm w-fit bg-neutral-100'><ArrowLeftIcon className='w-4 h-4' /><Trans>Terug naar inlogscherm</Trans></Link>
                </div>
                <h1 className={`${styles.h1} w-full`}><Trans>Wachtwoord vergeten</Trans></h1>
                <div className='w-full'>
                    <Label htmlFor='email'><Trans>E-mail</Trans></Label>
                    <Input value={email} onChange={({currentTarget})=>{setemail(currentTarget.value)}} onKeyDown={(e)=>{if(e.key === 'Enter'){ handleRequestPassword() }}} placeholder={`Email...`} id='email' type='email'/>
                </div>
                {
                    isSuccess
                    ?
                    <Link to="/login">
                        <Button>
                            <Trans>
                            Terug naar inlogscherm
                            </Trans>
                        </Button>
                    </Link>
                    :
                    <Button onClick={()=>{handleRequestPassword()}} disabled={isPending || isError} className='w-full gap-2'>
                        {isPending && <Spinner className='w-4 h-4'/>}
                        {isError && <AlertTriangle className='w-4 h-4'/>}
                        <Trans>Wachtwoord aanvragen</Trans>
                    </Button>
                }
                
            </div>
        </div>
    </div>
  )
}

export default ForgotPassword